import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Joyride from "react-joyride";

import { GetCreatedPapersThunk } from "../redux/thunk";
import { handleStage } from "../redux/slice";
import ErrorAlert from "./ErrorAlert";
import BootStrapTable from "../../components/table";
import { ProcessPapersData } from "./others";
import SkeletonLoader from "./loader/skeletonLoader";
import { getUserTourSteps } from "../../../../tour/QuestionPaperSteps"

const headers = [
  { label: "S No", accessor: "sno" },
  { label: "Exam Name", accessor: "examName" },
  { label: "Subject Name", accessor: "subjectName" },
  { label: "Class Name", accessor: "className" },
  { label: "Max Marks", accessor: "maxMarks" },
  { label: "Created At", accessor: "created_at" },
  { label: "Actions", accessor: "actions" },
];

function WorkSheets() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { createdpapers, error, loader } = useSelector(
    (store) => store.createQstnPaper
  );
  const { user } = useSelector((store) => store.authSlice);

  const userTourSteps = useMemo(() => getUserTourSteps(), []);
  const [currentStep, setCurrentStep] = useState(0);
  const [showTour, setShowTour] = useState(false);

  const processedPapers = ProcessPapersData(createdpapers, navigate);

  useEffect(() => {
    dispatch(GetCreatedPapersThunk({ type: 2 }));

    if (location.state?.resetData && user.admin_id !== 104) {
      dispatch(handleStage(1));

      // Wait for table render
      setTimeout(() => {
        const viewStepIndex = userTourSteps.findIndex(
          (step) => step.target === ".my-question-view-step"
        );

        if (viewStepIndex !== -1) {
          setCurrentStep(viewStepIndex);
          setShowTour(true);
        }
      }, 500);
    }
  }, [dispatch, location.state, user.admin_id, userTourSteps]);

  if (loader) return <SkeletonLoader type={1} />;

  return (
    <div>
      {error && <ErrorAlert message={error} />}

      {/* ✅ Walkthrough (same as Question Papers) */}
      {showTour && user.admin_id !== 104 && (
        <Joyride
          steps={userTourSteps}
          stepIndex={currentStep}
          showSkipButton={true}
          continuous
          showProgress={false}
          spotlightClicks={true}
          disableOverlay={false}
          disableOverlayClose={true}
          hideCloseButton={true}
          styles={{
            options: { zIndex: 10000 },
            buttonBack: { display: "none" },
            overlay: { zIndex: 8000 },
            buttonNext: {
              backgroundColor: "#6c4cff",
              cursor: "pointer",
            },
            tooltip: {
              maxWidth: "380px",
              minHeight: "50px",
              padding: "5px",
              borderRadius: "8px",
            },
            tooltipContent: {
              padding: "6px 8px",
              fontSize: "16px",
              lineHeight: "1.4",
            },
          }}
          callback={(data) => {
            const { action, index, type, status } = data;

            if (type === "tooltip:render") return;

            if (type === "step:after" && action === "next") {
              setCurrentStep(index + 1);
            }

            if (status === "finished" || status === "skipped") {
              setShowTour(false);
            }
          }}
        />
      )}

      <div className="container_bg">
        <div className="py-3 px-5 mx-5">
          {processedPapers.length > 0 ? (
            <BootStrapTable headers={headers} data={processedPapers} />
          ) : (
            <h5>No data Found.</h5>
          )}
        </div>
      </div>
    </div>
  );
}

export default WorkSheets;
